import { colors } from '../../constants';
const MuiTypography = {
  colorPrimary: {
    color: colors.textExtra.contrast,
    '&:hover,&:focus': {
      color: colors.textExtra.contrast
    }
  },
  colorSecondary: {
    color: colors.textExtra.heading,
    '&:hover,&:focus': {
      color: colors.textExtra.heading
    }
  },
  colorError: {
    '&:hover,&:focus': {
      color: colors.error.main
    }
  },
  colorTextPrimary: {
    '&:hover,&:focus': {
      color: colors.text.primary
    }
  },
  colorTextSecondary: {
    '&:hover,&:focus': {
      color: colors.text.secondary
    }
  }
};
export default MuiTypography;